import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateContext } from "@insite/client-framework/Context";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    UpdateContext as DefaultUpdateContext,
} from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { promoteContextCookiesToSharedDomain } from "@tSurya/Handlers/SharedCookieContext";

const UpdateContext: typeof DefaultUpdateContext = props => {
    updateContext({
        shipToId: props.parameter.shipToId,
        billToId: props.parameter.billToId,
        pickUpWarehouseId:
            props.parameter.fulfillmentMethod === FulfillmentMethod.Ship
                ? null
                : props.parameter.pickUpWarehouse?.id || undefined,
        settings: getSettingsCollection(props.getState()),
    });

    promoteContextCookiesToSharedDomain();
};

replaceInChain(chain, DefaultUpdateContext, UpdateContext);
